import { IEntity, IPagedSearchParams } from '@pf/shared-common';
import {
    PurchaseOrderHeaderSearchRequestParams,
    PurchaseOrderHeaderViewModelCreateBody,
    PurchaseOrderHeaderViewModelRead,
    PurchaseOrderLineViewModelRead,
} from '@control-tower/platform-orders';
import {
    Currency,
    LocationFragment,
    PurchaseOrderStatus,
    ResourceAuth,
    VendorFragment,
} from '@control-tower/platform-wms';
import { CustomFieldDto } from '@pf/shared/util-platform';

export type PurchaseOrderHeaderRead = PurchaseOrderHeaderViewModelRead &
    IEntity;
export type PurchaseOrderHeaderCreate = PurchaseOrderHeaderViewModelCreateBody;
export type PurchaseOrderHeaderSearchParams =
    PurchaseOrderHeaderSearchRequestParams & IPagedSearchParams;

export class PurchaseOrderHeaderDto implements IEntity {
    constructor(data: Partial<PurchaseOrderHeaderDto>) {
        Object.assign(this, data);
    }
    id!: string;
    orderNumber!: string;
    isDeleted?: boolean;
    createdDate?: string;
    modifiedDate?: string;
    requisitionId?: string | null;
    salesQuoteNumber?: string | null;
    salesQuoteDate?: string;
    totalPrice?: Currency;
    taxes?: Currency;
    orderTotalPrice?: Currency;
    dateRequiredBy?: string;
    purchaseOrderApprovedBy?: string | null;
    purchaseOrderApprovedDate?: string;
    termsAndConditions?: string | null;
    status?: PurchaseOrderStatus;
    resourceAuth?: ResourceAuth;
    notes?: string | null;
    externalReferenceId?: string | null;
    orderDate?: string | null;
    vendor?: VendorFragment;
    billToLocation?: LocationFragment;
    shipToLocation?: LocationFragment;
    purchaseOrderLines?: Array<PurchaseOrderLineViewModelRead> | null;
    customFields?: Array<CustomFieldDto> | null;
}
